import Imprint from "../views/privacy/Imprint.vue";
import Privacy from "../views/privacy/Privacy.vue";
import AGB from "../views/privacy/AGB.vue";

import LandingPageRoot from "../views/public/Root.vue";
import LandingPage from "../views/public/LandingPage.vue";
import LandingPageShop from "../views/public/Shop.vue";
import LandingPageContact from "../views/public/Contact.vue";
import LandingPageAboutMe from "../views/public/AboutMe.vue";

import StaunendLernen from "../views/public/subpages/StaunendLernen.vue";
import EigeneWege from "../views/public/subpages/EigeneWege.vue";
import FreiheitAtmen from "../views/public/subpages/FreiheitAtmen.vue";
import Breathwork from "../views/public/subpages/Breathwork.vue";


export const landingRoutes = [
    {
    path: "/",
    name: "landingpage",
    component: LandingPageRoot,
    children: [
      {
        path: "/",
        name: "landingpageMain",
        component: LandingPage,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: true
        }
      },
      {
        path: "/shop",
        name: "landingpageShop",
        component: LandingPageShop,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/kontakt",
        name: "landingpageContact",
        component: LandingPageContact,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: true
        }
      },
      {
        path: "/aboutme",
        name: "landingpageAboutMe",
        component: LandingPageAboutMe,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: true
        }
      },

      {
        path: "/staunendlernen",
        name: "staunendlernen",
        component: StaunendLernen,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/eigenewege",
        name: "eigenewege",
        component: EigeneWege,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/freiheitatmen",
        name: "freiheitatmen",
        component: FreiheitAtmen,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/breathwork",
        name: "breathwork",
        component: Breathwork,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/imprint",
        name: "imprint",
        component: Imprint,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/privacy",
        name: "privacy",
        component: Privacy,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/impressum",
        name: "impressum",
        component: Imprint,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/datenschutzerklaerung",
        name: "datenschutzerklaerung",
        component: Privacy,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
      {
        path: "/agb",
        name: "agb",
        component: AGB,
        meta: { seoPublic: true },
        props: {
          displayInNavigation: false
        }
      },
    ]
  },
]